import { FormControlLabel, RadioGroup } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import userStatusColor from '../../../../../utils/userStatusColor';
import { BpRadio } from '../style';
import query from '../../../../../constants/queries';
import { statusName } from '../helper';
import { OptionsProps } from '../types';
import { cn } from '../../../../../lib/utils';
import { Skeleton } from '../../../../../lib/skeleton';

const Options: React.FC<OptionsProps> = ({
    currentStatus,
    loadingStatus,
    isLoading,
    setLoadingStatus,
    endActivityStatus,
    startActivityStatus,
    showOptions
}) => {
    const queryClient = useQueryClient();

    const handleStatus = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (currentStatus === statusName.intake) return;

        setLoadingStatus(true);
        if (currentStatus !== '') {
            await endActivityStatus.mutateAsync(currentStatus);
        } else {
            await startActivityStatus.mutateAsync(statusName.working);
        }

        await startActivityStatus
            .mutateAsync(event.target.value)
            .then(() => queryClient.invalidateQueries([query.userStatuses]));
        setLoadingStatus(false);
    };

    const { available, inbound, followUp, meeting } = statusName;
    const containerClass = cn(
        'optionsContainer',
        currentStatus === statusName.intake && 'onIntake',
        showOptions && 'optionsContainer--show'
    );

    return (
        <div className={containerClass}>
            {!isLoading && !loadingStatus ? (
                <RadioGroup value={currentStatus} onChange={handleStatus}>
                    {[available, inbound, followUp, meeting, statusName.break].map((status) => {
                        const label = status === followUp ? 'Follow Up' : status;
                        const className = cn(
                            'optionsContainer__option capitalize',
                            currentStatus === status && 'invisible'
                        );

                        return (
                            <FormControlLabel
                                value={status}
                                control={
                                    <BpRadio
                                        bgColor={userStatusColor(status)}
                                        checkedColor={userStatusColor(status, true)}
                                    />
                                }
                                label={label}
                                labelPlacement="start"
                                className={className}
                                key={status}
                            />
                        );
                    })}
                </RadioGroup>
            ) : (
                <div className="flex flex-col">
                    {[...Array(4)].map(() => (
                        <div className="flex w-full justify-between items-center my-2 gap-2">
                            <Skeleton className="w-28 h-4" />
                            <Skeleton className="w-6 h-6 rounded-full" />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default Options;
